/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 260429
*/
'use strict';

import {
    formatAsShortDate,
    getStartAndEndOfMonth,
    getStartAndEndOfWeek

} from './ctssDateTime.js';
import {
    hasImgsToUpload,
    initImgCtrl,
    uploadImgToCloudAsync,
} from './ctssImg.js';
import {
    allSettled,
    autoComplete,
    getPromise,
    savePromise
} from './ctssJQuery.js';
import {
    integerOnly,
    numberOnly
} from './ctssVal.js';
import {
    getMembersDDLAsync
} from './snMembers.js'; 
import {
    appDebugMode,
    entireCongregationGroupID,
    entireCongregationGroupImgName,
    Features,
    getAppToken,
    getImgsBaseURLAsync,
    getTestFolderParams,
    ImgsFolder,
    setMenu
} from './snSite.js';

const { useTestFolder, testFolderParam } = getTestFolderParams();

const token = getAppToken();

const changeParticipantTrackingCode = () => {
    $('#lblMaxAttendees').addClass('hidden');
    $('#maxAttendees').addClass('hidden');
    $('#lblVolunteersNeeded').addClass('hidden');
    $('#volunteersNeeded').addClass('hidden');
    const value = $('#ddlParticipantTrackingCode').val();
    if ((value === "1") || (value === "3")) {
        $('#lblMaxAttendees').removeClass('hidden');
        $('#maxAttendees').removeClass('hidden');
    }
    if ((value === "2") || (value === "3")) {
        $('#lblVolunteersNeeded').removeClass('hidden');
        $('#volunteersNeeded').removeClass('hidden');
    }
};

const getCalendarGroupsAsync = async () => {
    const isAdmin = token.IsAdmin === "True";
    return await getPromise({
        url: `Groups/${token.CG}/${token.sub}/${isAdmin}/${Features.Events}/ToolBarData`
    });
}

const getDeletedEventsAsync = async () =>
    await getPromise({ url: `Events/${token.CG}/SoftDeleted` });

const getEventParticipantsCountAsync = async (params = {}) => 
    await getPromise({ url: `Events/${token.CG}/${params.eventId}/ParticipantsCount` });

const getEventTypesDataAsync = async () =>
    await getPromise({ url: `Events/${token.CG}/EventTypes` });

const getEventsAsync = async (startDate = null, endDate = null) => {

    let url = `Events/${token.CG}`;
    if (startDate !== null) {
        url += `?startDate=${startDate}`;
    }
    if (endDate !== null) {
        url += `&endDate=${endDate}`;
    }
    const events = await getPromise({ url }); /* return events between date range */

    if (appDebugMode) {
        console.log('events, startdate, enddate', events, startDate, endDate);
    }

    return events; /* All events */
}     

const getEventsForViewAsync = async (e) => {

    //console.log('navigate event', e);
    switch (e.view) {
        case 'week':
            const dtWeek = getStartAndEndOfWeek(e.date);
            startDate = formatAsShortDate(dtWeek.startOfWeek);
            endDate = formatAsShortDate(dtWeek.endOfWeek);
            await refreshCalendarAsync(); /* Refresh the calendar with week date range */
            break;
        case 'month':
            const dtMonth = getStartAndEndOfMonth(e.date);
            startDate = formatAsShortDate(dtMonth.startOfMonth);
            endDate = formatAsShortDate(dtMonth.endOfMonth);
            await refreshCalendarAsync(); /* Refresh the calendar with month range */
            break;
        case 'day':
            /* start at e.date and end at e.date for single day range */
            startDate = formatAsShortDate(e.date);
            endDate = formatAsShortDate(e.date);
            await refreshCalendarAsync(); /* Refresh the calendar for day */
            break;
        default:
    }
}

const getParticipantTrackingDDLDataAsync = async () =>
    await getPromise({ url: "Events/ParticipantTrackingDDL" });

const getScheduler = () => $('#scheduler').data('kendoScheduler');

const initDllDlg = () => {
    $('#divImagesDDL').removeClass('hidden');
    $('#ddlDlgLbl').text('Please restore the following event...');

    $('#ddlDlg').on('show.bs.modal', async (e) => {
        try {
            const deletedEvents = await getDeletedEventsAsync();
            if (deletedEvents.length === 0) { /* No deleted events */
            }
            else {
                $('#btnImagesDDL').html('Select event to restore <span class="caret"></span>');
                let content = deletedEvents.reduce((acc, e) => {
                    return acc + `<li data-event_id="${e.id}" class="dropdown-item pLeft10">` +
                        `${e.description}<span class="daysLeft">${e.daysBeforeDeletion} days</span></li>`
                }, '');
                $('#divImagesDDL .dropdown-menu').removeClass('hidden').html(content);
                $('#divImagesDDL .dropdown-menu').off('click').click(evt => {
                    const e = deletedEvents[deletedEvents.findIndex(x => x.id === evt.target.dataset.event_id)];
                    $('#imagesDDL_Value').val(e.id);
                    $('#btnImagesDDL').html(`Restore ${e.description}<span class="daysLeft">${e.daysBeforeDeletion} days <span class="caret"></span></span>`);
                });
            }
        }
        catch (error) { }
        $('#btn_ddl_OK').off('click').click(async () => {
            await savePromise({
                url: `Events/${token.CG}/${$('#imagesDDL_Value').val()}/RestoreEvent`,
                data: null
            }).then(async () => {
                await refreshCalendarAsync();
                await initRestoreEventBtnAsync();
                $('#ddlDlg').modal('hide');
            });
        });
    });
};

const initRestoreEventBtnAsync = async () => {
    try {
        const deletedEvents = await getDeletedEventsAsync();
        if (deletedEvents.length > 0) {
            if (document.getElementById('btnRestoreEvent') !== null) {
                $('#btnRestoreEvent').removeClass('hidden');
            } else {
                const btnRestoreEvent = "<button id='btnRestoreEvent' style='color: #428bca;' class='k-button' title='Restore deleted event...'" +
                    " data-toggle='modal' data-target='#ddlDlg'><span class='fa fa-recycle'></span> Restore </button>";

                $('#scheduler').data('kendoScheduler').toolbar
                    .append($(btnRestoreEvent));
            }
        }
        else {
            $('#btnRestoreEvent').addClass('hidden');
        }
    }
    catch (error) { };
}

const initScheduler = () => {
    const dt = new Date();
    $("#scheduler").kendoScheduler({
        date: dt, // Set initial date
        startTime: new Date(dt.getFullYear(), dt.getMonth(), dt.getDate(), 6, 0, 0), // Set start time
        height: 500,
        eventTemplate: $("#eventTemplate").html(),
        editable: {
            confirmation: false, // Removes default delete confirmation - use custom in onRemove event
            template: $("#eventEditor").html()
        },
        views: [
            { type: "day" },
            { type: "week", selected: true },
            { type: "month", adaptiveSlotHeight: true, eventsPerDay: 8, eventSpacing: 5 }
        ],
        navigate: async (e) => getEventsForViewAsync(e),
        dataSource: events,
        dataBound: onSchedulerDataBound,
        edit: onEditEvent,
        remove: onRemoveEventAsync,
        save: onSaveEventAsync,
        resources: [
            {
                field: "participantTrackingCode",
                dataSource: participantTrackingDDLData
            }
        ]
    });
}

const isAuthorized = (params) => {
    let isAuthorized = token.IsAdmin === "True";
    if (hasGroups && isAuthorized === false) /* Group leaders are authorized for their groups */ {
        if (token.GroupLeaderRights.length > 0) {
            const groupIDsAsCSV = snGroups.getGroupIDsFromRights({
                rights: token.GroupLeaderRights,
                asCSV: true
            });
            isAuthorized = groupIDsAsCSV.indexOf(params.groupID) > -1;
            if (appDebugMode) {
                console.log('group leader isAuthorized', isAuthorized);
            }
        }
    }
    return isAuthorized;
}

const onEditEvent = (e) => {

    if (appDebugMode) {
        console.log('onEditEvent(e)', e);
    }

    initImgCtrl({
        inputFileCtrl: '#editImgEvent',
        imgCtrl: '#imgEvent'
    });

    $('#editCost').off('keypress').on('keypress', numberOnly);
    $('#maxAttendees').off('keypress').on('keypress', integerOnly);
    $('#volunteersNeeded').off('keypress').on('keypress', integerOnly);
    $('#ddlParticipantTrackingCode').off('change').on('change', changeParticipantTrackingCode);

    const eventTitle = e.event.title;
    const scheduler = getScheduler();
    scheduler.options.editable.confirmation = eventTitle.toLowerCase().indexOf('event') > -1
        ? `Are you sure you want to delete ${eventTitle}?`
        : `Are you sure you want to delete ${eventTitle} event?`;

    if (hasGroups) {
        if (e.event.id === 0) {  /* New event */
            $('#divGroupDisplay').addClass('hidden');
            $('#divGroupDDL').removeClass('hidden');
            $('#hiddenGroupID').val("0");

            //$('#btnImgsDDL').html(`<img src="${groupImgsBaseURL}${groups[0].imgName}"> ${groups[0].text} <span class="caret"></span></span>`)
            $('#btnImgsDDL').html(`<img src="${groups[0].imgSrc}"> ${groups[0].text} <span class="caret"></span></span>`)
            let content = groups.reduce((acc, g) => {
                return acc + `<li data-group_id="${g.value}" class="dropdown-item">` +
                    //`<img class="grpimg" src="${groupImgsBaseURL}${g.imgName}" data-group_id="${g.value}" data-img_name="${g.imgName}">${g.text}</li>`;
                    `<img class="grpimg" src="${g.imgSrc}" data-group_id="${g.value}" data-img_name="${g.imgName}">${g.text}</li>`;
            }, '');
            $('#divGroupDDL .dropdown-menu').html(content);
            //$('divGroupDDL .dropdown-menu .imgGrp').off('error').on('error', (e) => {
            //    e.target.src = `${testFolderImgBaseURL}${e.target.dataset.img_name}`;
            //});

            $('#divGroupDDL .dropdown-menu > li').off('click').click(e => {
                const g = groups[groups.findIndex(x => x.value === e.target.dataset.group_id)];
                $('#hiddenGroupID').val(g.value);
                $('#btnImgsDDL')
                    .html(`<img src="${g.imgSrc}"> ${g.text} <span class="caret"></span></span>`);
            //        .html(`<img src="${groupImgsBaseURL}${g.imgName}"> ${g.text} <span class="caret"></span></span>`)
            //        .off('error').on('error', (e) => {
            //            e.target.src = `${testFolderImgBaseURL}${g.imgName}`;
            //        });
            });

        } else { /* Existing event */
            const g = groups.find(x => x.value === e.event.groupID);
            //$('#grpImg').off('error').on('error', (e) => {
            //    e.target.src = `${testFolderImgBaseURL}$${g.imgName}`;
            //});
            //$('#grpImg').prop('src', groupImgsBaseURL + g.imgName);
            $('#grpImg').prop('src', g.imgSrc);
            $('#grpDesc').html(g.text);
            $('#divGroupDDL').addClass('hidden');
            $('#divGroupDisplay').removeClass('hidden');

            if (isAuthorized({ groupID: e.event.groupID }) === false) {
                $('.k-window-title').text('You are not authorized to edit this event...');
                $('.k-scheduler-delete,.k-scheduler-update').addClass('hidden');
                $('.k-scheduler-cancel').text('OK');
            };
            $('.k-textbox').attr('readonly', isAuthorized === false);
        }
    }

    if (e.event.organizerID !== "0") {
        const idx = members.findIndex(x => x.value === e.event.organizerID);
        if (idx > -1) {
            $('#OrganizerID').val(members[idx].text);
        }
    }

    const container = e.container;

    const participantTrackingCodes = e.sender.resources[0].dataSource.data().toJSON();

    container.find("[data-container-for=ddlParticipantTrackingCode]")
        .find("[data-role=dropdownlist]")
        .data("kendoDropDownList")
        .setDataSource(participantTrackingCodes);

    $("#ddlParticipantTrackingCode")
        .data("kendoDropDownList")
        .value(e.event.participantTrackingCode ?? "0");

    autoComplete({
        ctrlNm: '#OrganizerID',
        source: members.map(x => x.text)
    });

    if (e.event.id !== 0) {
        if ((e.event.eventImgURL !== null) && (e.event.eventImgURL.length > 0)) {
            $('#imgEvent').off('error').on('error', (e) => {
                const imgName = e.target.src.substring(e.target.src.lastIndexOf('/') + 1);
                e.target.src = `${testFolderImgBaseURL}${imgName}`;
            });
            $('#imgEvent').prop('src', e.event.eventImgURL);
        }
    }

    changeParticipantTrackingCode();

}

const onRemoveEventAsync = async (e) => {
    await savePromise({
        url: `Events/${token.CG}/${e.event.id}/CancelEvent`,
        data: null
    }).then(async () => {
        await refreshCalendarAsync();
        await initRestoreEventBtnAsync();
    });
}

const onSchedulerDataBound = (e) => {

    const scheduler = e.sender;
    $(".k-event").each(function () {
        const uid = $(this).data("uid");
        if (uid) {
            const event = scheduler.occurrenceByUid(uid);
            if (event) {
                $(this).find(".k-event-delete").click(async (e) => {

                    if (hasGroups && isAuthorized({ groupID: event.groupID }) === false) {
                        setTimeout(() => {
                            $('.k-scheduler-delete').addClass('hidden');
                            $('.k-scheduler-cancel').text('OK');
                            $('.k-popup-message').text('You are not authorized to delete this event');
                        }, 0);
                        return;
                    }
                    try {
                        const cnt = await getEventParticipantsCountAsync({ eventId: event.id });
                        const messageElement = $('.k-popup-message');
                        let currentText = messageElement.text();
                        const newText = (cnt > 0)
                            ? `There are ${cnt} people signed up to attend "${event.title}". ${currentText}`
                            : currentText.replace('this', `the "${event.title}"`);
                        messageElement.text(newText);

                    }
                    catch (error) { }
                });;
            }
        }
    })
}    

const onSaveEventAsync = async (e) => {
    const groupID = hasGroups
        ? $('#hiddenGroupID').val()
        : entireCongregationGroupID;

    if (groupID !== e.event.groupID) {
        e.event.groupID = groupID;
        e.event.groupImgName = hasGroups
            ? groups[groups.findIndex(x => x.value === e.event.groupID)].text
            : entireCongregationGroupImgName;
        e.event.dirty = true;
    }
    const name = $('#OrganizerID').val();
    if ((name.length === 0) && (e.event.organizerID !== '0')) {
        e.event.organizerID = '0';
        e.event.dirty = true;
    } else {
        if (name.length > 0) {
            const idx = members.findIndex(x => x.text === name);
            if (idx === -1) {
                $('#divErrMsg')
                    .text(name + ' is not a church member...')
                    .removeClass('hidden');
                e.preventDefault();
                return;
            }
            if (members[idx].value !== e.event.organizerID) {
                e.event.organizerID = members[idx].value;
                e.event.dirty = true;
            }
        }
    }

    if (hasImgsToUpload()) {
        await uploadImgToCloudAsync({
            divErrMsg: 'divUpdDlgErrMsg',
            imgsFolder: ImgsFolder.Events,
            imgCtrl: '#imgEvent',
            imgName: $('#hiddenImgName').val(),
            addThumbNail: true,
            url: 'Storage/Img',
            useTestFolder: useTestFolder,
            postOnload: async (imgNm) => {
                $('#hiddenImgNm').val(imgNm);
                e.event.imgsFolder = useTestFolder ? ImgsFolder.TestFolder : ImgsFolder.Events;
                e.event.imgName = imgNm;
                e.event.eventImgURL = eventImgsBaseURL + imgNm;
                e.event.dirty = true;
                await saveEventAsync(e.event)
                    .then(async () => await refreshCalendarAsync());
            }
        });
    } else {
        await saveEventAsync(e.event)
            .then(async () => await refreshCalendarAsync());
    }
}

const refreshCalendarAsync = async () => {
    try {
        events = await getEventsAsync(startDate, endDate);
        const scheduler = $('#scheduler').data('kendoScheduler');
        scheduler.setDataSource(new kendo.data.SchedulerDataSource({ data: events }));
        scheduler.dataSource.read();

    }
    catch (error) { }
}

const saveEventAsync = async (e) => {

    const s1 = e.start.toString();
    const s2 = s1.substring(4, s1.lastIndexOf(':') + 3);
    const s3 = e.end.toString();
    const s4 = s3.substring(4, s3.lastIndexOf(':') + 3);
    const se = {
        id: e.id,
        cg: token.CG,         
        groupID: e.groupID,
        title: e.title,
        location: e.location,
        shortDesc: e.shortDesc,
        description: e.description,
        start: s2,
        end: s4,
        startTimezone: e.startTimezone,
        endTimezone: e.endTimezone,
        recurrenceRule: e.recurrenceRule,
        recurranceId: e.recurrenceId,
        recurranceException: e.recurrenceException,
        isAllDay: e.isAllDay,
        ownerID: e.ownerID,
        participantTrackingCode: e.participantTrackingCode, 
        maxAttendees: e.maxAttendees,
        volunteersNeeded: e.volunteersNeeded,
        cost: e.cost,
        imgsFolder: useTestFolder ? ImgsFolder.TestFolder : ImgsFolder.Events,
        imgName: e.imgName,
        organizerID: e.organizerID
    };

    await savePromise({
        url: `Events/${token.CG}`,
        data: se
    }).then(data => e.id = data);
}

/* public variables and functions */
//var calendarGroups = []; /* All groups - so group leaders can see events that are not in their group */

let eventImgsBaseURL = ''; /* Base URL for event images */
let eventTypes = []; /* Event types for the dropdown list */
let events = []; /* All events for the calendar */
let groups = []; /* All groups - so group leaders can see events that are not in their group */
let groupImgsBaseURL = ''; /* Base URL for group images */
let hasGroups = false;
let members = [];
let participantTrackingDDLData = []; /* Data for the participant tracking dropdown list */
let testFolderImgBaseURL = ''; /* Base URL for test folder images */

let startDate = null; /* Start date for the calendar */
let endDate = null; /* End date for the calendar */

const initAsync = async () => {

    setMenu();


    /* The default calender view is the current week */

    const dtRange = getStartAndEndOfWeek();
    startDate = formatAsShortDate(dtRange.startOfWeek);
    endDate = formatAsShortDate(dtRange.endOfWeek);

    const [eventsData,
        calendarGroupsData,
        eventImgsBaseURLData,
        eventTypesData,
        gImgsBaseURL,
        participantTrackingDDLDataValues,
        membersDDLDataValues,
        tImgsBaseURL
    ] =
        await allSettled({
            promises: [
                getEventsAsync(startDate, endDate),
                getCalendarGroupsAsync(),
                getImgsBaseURLAsync(ImgsFolder.Events, testFolderParam),
                getEventTypesDataAsync(),
                getImgsBaseURLAsync(ImgsFolder.Groups),
                getParticipantTrackingDDLDataAsync(),
                getMembersDDLAsync(),
                getImgsBaseURLAsync(ImgsFolder.TestFolder),
            ]
        });

    if (eventsData.status !== 'rejected') {
        events = eventsData.value;
    }
    if (calendarGroupsData.status !== 'rejected') {
        groups = calendarGroupsData.value.groups;
        hasGroups = calendarGroupsData.value.hasGroups;
    };
    if (eventImgsBaseURLData.status !== 'rejected') {
        eventImgsBaseURL = eventImgsBaseURLData.value;
    };
    if (eventTypesData.status !== 'rejected') {
        eventTypes = eventTypesData.value;
    }
    if (gImgsBaseURL.status !== 'rejected') {
        groupImgsBaseURL = gImgsBaseURL.value;
    }
    if (participantTrackingDDLData.status !== 'rejected') {
        participantTrackingDDLData = participantTrackingDDLDataValues.value;
    };
    if (membersDDLDataValues.status !== 'rejected') {
        members = membersDDLDataValues.value;
    }
    if (tImgsBaseURL.status !== 'rejected') {
        testFolderImgBaseURL = tImgsBaseURL.value;
    }

    initScheduler();

    await initRestoreEventBtnAsync();

    initDllDlg();

};

window.snSchedule = {
    initAsync
};
